import { Box, Text, TextButton } from '@wix/design-system';
import { StatusAlertSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { BiCtaNames } from '../../bi/types';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../hooks/use-open-article-by-editor-host';
export const ManualTask = _ref => {
  let {
    title,
    description,
    articleKey,
    ariaLabel,
    learnMore
  } = _ref;
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const biLogger = useBiLogger();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "8px"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(StatusAlertSmall, null)), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "3px",
    minWidth: "0"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "bold"
  }, title), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    secondary: true
  }, description)), articleKey && /*#__PURE__*/React.createElement(TextButton, {
    ariaLabel: ariaLabel,
    paddingBottom: "SP1",
    size: "tiny",
    underline: "always",
    ellipsis: true,
    onClick: () => {
      biLogger.ctaClick({
        ctaName: `${BiCtaNames.ManualTask}-${ariaLabel}`
      });
      openSelectedArticle(editorHost, articleKey);
    }
  }, learnMore)));
};
//# sourceMappingURL=manual-task.js.map